import React from 'react';

import styles from './styles.module.scss';

interface I_LoadingSpinnerProps {
    showLoad: boolean;
    device?: 'pc' | 'm';
}

const LoadingSpinner = (props: I_LoadingSpinnerProps) => {
    const { showLoad } = props;

    if (!showLoad) {
        return <div />;
    }

    return (
        <span className={styles['loadingSpinner']}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
            >
                <path
                    d="M20 10C20 14.9251 15.7932 19 10.5 19C5.20676 19 1 14.9251 1 10C1 5.07485 5.20676 1 10.5 1C15.7932 1 20 5.07485 20 10Z"
                    stroke="white"
                    strokeOpacity="0.2"
                    strokeWidth="2"
                />
                <path
                    d="M19.969 10C20.5384 10 21.0058 9.53706 20.9443 8.97096C20.84 8.01083 20.59 7.06829 20.2007 6.17317C19.6731 4.95991 18.8996 3.85752 17.9246 2.92893C16.9496 2.00035 15.7921 1.26375 14.5182 0.761205C13.5473 0.3782 12.5233 0.136856 11.4807 0.0437086C10.9405 -0.00454874 10.5 0.43963 10.5 0.981942C10.5 1.52425 10.941 1.95824 11.4799 2.01826C12.2515 2.10418 13.0085 2.29134 13.7291 2.5756C14.7528 2.97945 15.683 3.57138 16.4665 4.31761C17.25 5.06383 17.8716 5.94972 18.2956 6.92471C18.5813 7.58148 18.7735 8.27001 18.8686 8.97207C18.945 9.53634 19.3995 10 19.969 10Z"
                    fill="white"
                />
                <path
                    d="M1.02495 10C0.458885 10 -0.00568581 10.4602 0.0550842 11.023C0.158985 11.9852 0.409134 12.9298 0.799265 13.8268C1.32694 15.0401 2.10036 16.1425 3.07538 17.0711C4.05039 17.9997 5.20791 18.7362 6.48182 19.2388C7.4545 19.6225 8.48051 19.864 9.52512 19.9568C10.0621 20.0045 10.5 19.563 10.5 19.0239C10.5 18.4848 10.0617 18.0533 9.52582 17.9941C8.75067 17.9084 7.99013 17.7207 7.26628 17.4351C6.24107 17.0307 5.30954 16.4379 4.52487 15.6906C3.74021 14.9433 3.11778 14.0561 2.69312 13.0797C2.40604 12.4197 2.21315 11.7276 2.1183 11.0219C2.04288 10.4609 1.59101 10 1.02495 10Z"
                    fill="white"
                />
            </svg>
        </span>
    );
};

export default LoadingSpinner;
